import {customElement, query, queryAll} from "lit/decorators.js";
import {SearchFacade} from "./searchFacade";
import {resolve} from "../../../container";
import {ScrollableBar} from "../../../page/elements/scrollableBar";
import {html, type PropertyValues, type TemplateResult} from "lit";
import {ResizeObserverFactory} from "../../../common/observation";
import {templateContent} from "lit/directives/template-content.js";
import {SearchGroupTab} from "./searchGroupTab";
import type {DirectiveResult} from "lit/directive";

@customElement("eop-search-group-tabs")
export class EopSearchGroupTabs extends ScrollableBar {

    @query(".content-search-tab-items")
    protected scrollableArea: HTMLElement;
    @queryAll(".content-search-tab-item")
    private searchTabNodes: NodeListOf<HTMLElement>;
    @queryAll("eop-search-group-tab")
    private searchTabComponents: NodeListOf<SearchGroupTab>;
    private focusResizeObserver: ResizeObserver;

    private searchTabs: DirectiveResult[];

    protected items(): HTMLElement[] {
        return Array.from(this.searchTabNodes);
    }

    public constructor(
        private searchFacade: SearchFacade = resolve(SearchFacade),
        resizeObserverFactory: ResizeObserverFactory = resolve(ResizeObserverFactory)
    ) {
        super();
        this.focusResizeObserver = resizeObserverFactory.create(() => this.searchFacade.focus());
    }

    public connectedCallback(): void {
        super.connectedCallback();
        this.focusResizeObserver.observe(this);
        this.searchTabs = Array.from(this.querySelectorAll<HTMLTemplateElement>(".content-search-tab-item-template"))
            .map(template => templateContent(template));
    }

    public disconnectedCallback(): void {
        this.focusResizeObserver.disconnect();
        super.disconnectedCallback();
    }

    protected firstUpdated(_changedProperties: PropertyValues): void {
        super.firstUpdated(_changedProperties);
        const activeGroup = this.searchFacade.activeGroup();
        if (!activeGroup || activeGroup.name === "default") {
            this.searchTabComponents.item(0)?.activate();
        }
    }

    public render(): TemplateResult {
        return html`
            <div class="content-search-tabs-container">
                <nav class="content-search-tabs">
                    <div class="content-search-tab-items horizontally-scrollable-area"
                         @scroll=${this.toggleScrollButtonVisibility}
                         @touchend=${{handleEvent: () => this.toggleScrollButtonVisibility(), passive: true}}
                    >
                        <div aria-hidden="true">
                            <eop-swipe-hint></eop-swipe-hint>
                        </div>
                        ${this.searchTabs}
                    </div>
                    ${this.renderScrollLeftButton()}
                    ${this.renderScrollRightButton()}
                </nav>
            </div>
        `;
    }
}
